<template>
    <div>
      <div class="kit__utils__heading d-flex flex-row justify-content-start align-items-center">
            <h5><span class="mr-3">{{titleTable}}</span></h5>
            <h5><span class="mr-3 text-warning font-weight-bold">{{providerName ? providerName.toUpperCase() : ""}}</span></h5>
        </div>

      <div class="card-header card-header-flex">

          <div class="d-flex flex-column justify-content-center mr-auto">
            <b-dropdown variant="Clear" text="Export ข้อมูล" class="mb-3 mr-2">
              <b-dropdown-item type="button" v-clipboard:copy="JSON.stringify(this.selectedRowKeys)"
                v-clipboard:success="onCopy" v-clipboard:error="onError"><i class="fa fa-copy mr-1" />Copy!
              </b-dropdown-item>
              <b-dropdown-item @click="checkDataExcel(json_data)">
                <download-excel :data="json_data" :fields="json_fields" :name="fileName">
                  <i class="fa fa-file-excel-o mr-1" />Export Excel Select
                </download-excel>
              </b-dropdown-item>
              <b-dropdown-item @click="exportAll(dataSource.data)">
                <download-excel :data="dataSource.data" :fields="json_fields" :name="fileName">
                  <i class="fa fa-file-excel-o mr-1" />Export Excel All
                </download-excel>
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="d-flex flex-column justify-content-center">
            <a-checkbox @change="getAutoRefresh(refresh)">
              รีเฟรชอัตโนมัติ {{(this.refresh) ? myVal : ''}}
            </a-checkbox>
          </div>
          <div class="d-flex flex-column justify-content-center">
              <a class="btn btn-primary" href="javascript: void(0);" @click="getData()"><i class="fe fe-rotate-cw mr-1" /> รีเฟรช</a>
          </div>
      </div>
      <a-table :dataSource="dataSource.data" :columns="columns"  :loading="isLoading" :row-selection="rowSelection"  :rowKey='dataSource.rowKey' :scroll="{ x: 1300 }" :pagination="{defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger : true }">
      </a-table>
    </div>
  </template>

<script>
import moment from 'moment'
import Swal from 'sweetalert2'
// import axios from 'axios'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
function CopyMe(TextToCopy) {
  var TempText = document.createElement('textarea')
  TempText.value = TextToCopy
  document.body.appendChild(TempText)
  TempText.select()
  document.execCommand('copy')
  document.body.removeChild(TempText)
}

export default {
  props: [
    'dataSource',
    'columns',
    'titleTable',
    'rowKey',
    'isLoading',
    'providerName',
  ],
  components: {
    // eslint-disable-next-line vue/no-unused-components
    data: {
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8',
          },
        ],
      ],
    },
  },
  computed: {
    myVal() {
      if (this.ctr === 0) {
        this.reCountdown()
      }
      return this.ctr
    },
    rowSelection() {
      const { selectedRowKeys } = this
      return {
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,

        selections: [
          {
            key: 'all-data',
            text: 'เลือกทั้งหมด',
            onSelect: () => {
              this.selectedRowKeys = this.dataSource.data.map((result) => {
                return result.depositCode
              })
            },
          },
          {
            key: 'del-data',
            text: 'ลบทั้งหมด',
            onSelect: () => {
              this.selectedRowKeys = []
            },
          },
        ],
        onSelection: this.onSelection,
      }
    },
  },
  data() {
    return {
      json_data: [],
      json_fields: {},
      fileName: {},
      dataExport: [],
      selectedRowKeys: [],
      refresh: false,
      countdown: false,
      counters: '',
      counters2: '',
      ctr: 5,
    }
  },
  methods: {

    copyLink(link) {
      CopyMe(link)
      Toast.fire({ icon: 'success', title: 'success copy' })
    },
    checkDataExcel (data) {
      if (data.length === 0) {
        Toast.fire({ icon: 'error', title: 'กรุณาเลือกข้อมูลที่ต้องการ Export' })
        return false
      }
    },
    dataToExcel (data) {
      if (data.length > 0) {
        const dataresult = []
        data.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataSource.data.find((dataResult) => {
            if (dataResult.depositCode === result) {
              return true
            }
          })
          const resultData = {
            depositCode: item.depositCode,
            username: item.username,
            bankServiceUser: item.bankServiceUser,
            bankServiceSystem: item.bankServiceSystem,
            amount: item.amount,
            depositStatus: this.getStatus('sbo', item.depositStatus).name,
            createdAt: moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss'),
          }
          dataresult.push(resultData)
        })
        this.json_data = dataresult
      }
    },
    exportAll (obj) {
      this.dataExport = []
      let resultData = {}
      obj.map(element => {
        resultData = {
          depositCode: element.depositCode,
          username: element.username,
          bankServiceUser: element.bankServiceUser,
          bankServiceSystem: element.bankServiceSystem,
          amount: element.amount,
          depositStatus: this.getStatus('sbo', element.depositStatus).name,
          createdAt: moment(element.createdAt).format('DD/MM/YYYY HH:mm:ss'),
        }
        this.dataExport.push(resultData)
      })
    },
    onCopy: function (e) {
      const dataJson = JSON.parse(e.text)
      let row = ''
      if (dataJson.length > 0) {
        dataJson.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataSource.data.find((dataResult) => {
            if (dataResult.depositCode === result) {
              return true
            }
          })
          const resultData = {
            depositCode: item.depositCode,
            username: item.username,
            bankServiceUser: item.bankServiceUser,
            bankServiceSystem: item.bankServiceSystem,
            amount: item.amount,
            depositStatus: this.getStatus('sbo', item.depositStatus).name,
            createdAt: moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss'),
          }
          const convertObj = Object.values(resultData)
          const col = convertObj.join(' \t ')
          row += `${col} \n`
        })
        // this.clipboard(row)
        // alert('success copy')
        CopyMe(row)
        Toast.fire({ icon: 'success', title: 'success copy' })
      } else {
        // alert('กรุณาเลือกข้อมูลที่ต้องการคัดลอก')
        Toast.fire({ icon: 'error', title: 'กรุณาเลือกข้อมูลที่ต้องการคัดลอก' })
      }
    },
    onError: function (e) {
      // alert('Failed to copy texts')
      Toast.fire({ icon: 'error', title: 'Failed to copy texts' })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    async getData() {
      this.$emit('load-data')
    },
    getAutoRefresh(refresh) {
      if (!refresh) {
        this.refresh = true
        this.ReloadData(true)
      } else {
        this.refresh = false
        this.ReloadData(false)
      }
    },
    ReloadData (value) {
      if (value) {
        this.countdown = true
        this.counters = setInterval(function () {
          this.getData()
        }.bind(this), 5000)
        this.counters2 = setInterval(function () {
          this.ctr = this.ctr - 1
        }.bind(this), 1000)
      } else {
        clearInterval(this.counters)
        clearInterval(this.counters2)
        this.ctr = 5
      }
    },
    reCountdown () {
      this.ctr = 5
    },
  },
  async created() {
    this.fileName = this.dataSource.fileName
    this.json_fields = this.dataSource.json_fields
    this.json_data = this.dataSource.data
  },
}
</script>

  <style>
  .custom-filter-dropdown {
    padding: 8px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  .highlight {
    background-color: rgb(255, 192, 105);
    padding: 0px;
  }
  </style>
